module.exports = __webpack_public_path__ + "img/images-user.a62e65c6.svg";